import { Font, StyleSheet } from '@react-pdf/renderer';

// Register Inter fonts
Font.register({
  family: 'Inter',
  fonts: [{ src: '/fonts/InterVariable.ttf' }, { src: '/fonts/InterVariable-Italic.ttf', fontStyle: 'italic' }]
});

export const styles = StyleSheet.create({
  table: {
    width: 'auto',
    borderWidth: 1,
    borderBottom: 0
  },
  tableRow: {
    margin: 'auto',
    width: '100%',
    flexDirection: 'row',
    borderBottomWidth: 1
  },
  tableHeaderCell: {
    fontWeight: 'bold',
    fontSize: 10,
    textAlign: 'center',
    alignItems: 'center',
    width: '100%',
    padding: 1
  },
  tableCell: {
    width: '100%',
    padding: '0px 5px',
    fontSize: 8,
    textAlign: 'center'
  },
  tableCellSm: {
    margin: 1,
    fontSize: 5,
    width: '100%',
    textAlign: 'center'
  },
  box: {
    width: '90%',
    height: '90%',
    borderRadius: 4,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export const fontStyles = StyleSheet.create({
  normal: {
    fontFamily: 'Inter'
  },
  bold: {
    fontFamily: 'Inter',
    fontWeight: 700
  },
  italic: {
    fontFamily: 'Inter',
    fontStyle: 'italic'
  }
});
